import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/carving`;

interface Props {
    className?: string;
}

export const CarvingInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            文字刻印の決め方
        </Title>
        <Image src={`${IMG_PATH}/carving.png`} />

        <Paragraph>
            レーザー刻印でシャフトに文字を刻印いたします。
            矢の取り間違いが起きた時、また忘れてしまった時などにご自身の矢と見分けをつけるのに役立ちます。
        </Paragraph>

        <Paragraph>
            まずは刻印したい文字の入力をしてから、ご希望の書体を選択してください。
            ジュラルミン矢の場合は銀色に、カーボン矢の場合は黒色に近い色で仕上がります。
            シルバーのジュラルミンシャフトに銀の文字色でも刻印した文字を認識できます。
        </Paragraph>

        <Paragraph>
            刻印する位置・文字の大きさ等はシャフトの種類などに応じて最適な位置に刻印します。
            細かい位置の指定など、受け付けておりませんので予めご了承ください。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpCarving: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <CarvingInner />
            </div>
        </div>
    </Panel>
);
